"use strict";
/**
 * This file was auto-generated. Do not make direct changes.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAbout = getAbout;
exports.createAccount = createAccount;
exports.getDataTypes = getDataTypes;
exports.getAccountDataSettings = getAccountDataSettings;
exports.upsertAccountDataSettings = upsertAccountDataSettings;
exports.getAccount = getAccount;
exports.deleteAccount = deleteAccount;
exports.getCounterfactualSafe = getCounterfactualSafe;
exports.deleteCounterfactualSafe = deleteCounterfactualSafe;
exports.getCounterfactualSafes = getCounterfactualSafes;
exports.createCounterfactualSafe = createCounterfactualSafe;
exports.deleteCounterfactualSafes = deleteCounterfactualSafes;
exports.getNonce = getNonce;
exports.verify = verify;
exports.getBalances = getBalances;
exports.getSupportedFiatCodes = getSupportedFiatCodes;
exports.getChains = getChains;
exports.getChain = getChain;
exports.getAboutChain = getAboutChain;
exports.getBackbone = getBackbone;
exports.getMasterCopies = getMasterCopies;
exports.getIndexingStatus = getIndexingStatus;
exports.getCollectibles = getCollectibles;
exports.getCampaigns = getCampaigns;
exports.getCampaignById = getCampaignById;
exports.getCampaignActivities = getCampaignActivities;
exports.getCampaignLeaderboard = getCampaignLeaderboard;
exports.getCampaignRank = getCampaignRank;
exports.getLeaderboard = getLeaderboard;
exports.getLockingRank = getLockingRank;
exports.getLockingHistory = getLockingHistory;
exports.getContract = getContract;
exports.getDataDecoded = getDataDecoded;
exports.getDelegates = getDelegates;
exports.postDelegate = postDelegate;
exports.deleteDelegate = deleteDelegate;
exports.deleteSafeDelegate = deleteSafeDelegate;
exports.getDelegatesV2 = getDelegatesV2;
exports.postDelegateV2 = postDelegateV2;
exports.deleteDelegateV2 = deleteDelegateV2;
exports.addRecoveryModule = addRecoveryModule;
exports.deleteRecoveryModule = deleteRecoveryModule;
exports.getEstimation = getEstimation;
exports.getMessageByHash = getMessageByHash;
exports.getMessagesBySafe = getMessagesBySafe;
exports.createMessage = createMessage;
exports.updateMessageSignature = updateMessageSignature;
exports.registerDevice = registerDevice;
exports.unregisterDevice = unregisterDevice;
exports.unregisterSafe = unregisterSafe;
exports.getSafesByOwner = getSafesByOwner;
exports.getAllSafesByOwner = getAllSafesByOwner;
exports.relay = relay;
exports.getRelaysRemaining = getRelaysRemaining;
exports.getSafeApps = getSafeApps;
exports.getSafe = getSafe;
exports.getNonces = getNonces;
exports.getSafeOverview = getSafeOverview;
exports.getSubmission = getSubmission;
exports.createSubmission = createSubmission;
exports.getTransactionById = getTransactionById;
exports.getMultisigTransactions = getMultisigTransactions;
exports.deleteTransaction = deleteTransaction;
exports.getModuleTransactions = getModuleTransactions;
exports.addConfirmation = addConfirmation;
exports.getIncomingTransfers = getIncomingTransfers;
exports.previewTransaction = previewTransaction;
exports.getTransactionQueue = getTransactionQueue;
exports.getTransactionsHistory = getTransactionsHistory;
exports.proposeTransaction = proposeTransaction;
exports.getCreationTransaction = getCreationTransaction;
exports.getTransactionConfirmationView = getTransactionConfirmationView;
const client_1 = require("./client");
async function clientRequest(method, path, options) {
  const client = (0, client_1.getClient)();
  const _method = method.toUpperCase();
  // @ts-expect-error - paths is generated by openapi-typescript
  const fn = client[_method];
  const { data, error } = await fn(path, options);
  if (error || !data) {
    throw error;
  }
  return data;
}
async function getAbout(options) {
  return clientRequest("get", "/about", options);
}
async function createAccount(options) {
  return clientRequest("post", "/v1/accounts", options);
}
async function getDataTypes(options) {
  return clientRequest("get", "/v1/accounts/data-types", options);
}
async function getAccountDataSettings(options) {
  return clientRequest("get", "/v1/accounts/{address}/data-settings", options);
}
async function upsertAccountDataSettings(options) {
  return clientRequest("put", "/v1/accounts/{address}/data-settings", options);
}
async function getAccount(options) {
  return clientRequest("get", "/v1/accounts/{address}", options);
}
async function deleteAccount(options) {
  return clientRequest("delete", "/v1/accounts/{address}", options);
}
async function getCounterfactualSafe(options) {
  return clientRequest(
    "get",
    "/v1/accounts/{address}/counterfactual-safes/{chainId}/{predictedAddress}",
    options,
  );
}
async function deleteCounterfactualSafe(options) {
  return clientRequest(
    "delete",
    "/v1/accounts/{address}/counterfactual-safes/{chainId}/{predictedAddress}",
    options,
  );
}
async function getCounterfactualSafes(options) {
  return clientRequest(
    "get",
    "/v1/accounts/{address}/counterfactual-safes",
    options,
  );
}
async function createCounterfactualSafe(options) {
  return clientRequest(
    "put",
    "/v1/accounts/{address}/counterfactual-safes",
    options,
  );
}
async function deleteCounterfactualSafes(options) {
  return clientRequest(
    "delete",
    "/v1/accounts/{address}/counterfactual-safes",
    options,
  );
}
async function getNonce(options) {
  return clientRequest("get", "/v1/auth/nonce", options);
}
async function verify(options) {
  return clientRequest("post", "/v1/auth/verify", options);
}
async function getBalances(options) {
  return clientRequest(
    "get",
    "/v1/chains/{chainId}/safes/{safeAddress}/balances/{fiatCode}",
    options,
  );
}
async function getSupportedFiatCodes(options) {
  return clientRequest("get", "/v1/balances/supported-fiat-codes", options);
}
async function getChains(options) {
  return clientRequest("get", "/v1/chains", options);
}
async function getChain(options) {
  return clientRequest("get", "/v1/chains/{chainId}", options);
}
async function getAboutChain(options) {
  return clientRequest("get", "/v1/chains/{chainId}/about", options);
}
async function getBackbone(options) {
  return clientRequest("get", "/v1/chains/{chainId}/about/backbone", options);
}
async function getMasterCopies(options) {
  return clientRequest(
    "get",
    "/v1/chains/{chainId}/about/master-copies",
    options,
  );
}
async function getIndexingStatus(options) {
  return clientRequest("get", "/v1/chains/{chainId}/about/indexing", options);
}
async function getCollectibles(options) {
  return clientRequest(
    "get",
    "/v2/chains/{chainId}/safes/{safeAddress}/collectibles",
    options,
  );
}
async function getCampaigns(options) {
  return clientRequest("get", "/v1/community/campaigns", options);
}
async function getCampaignById(options) {
  return clientRequest("get", "/v1/community/campaigns/{resourceId}", options);
}
async function getCampaignActivities(options) {
  return clientRequest(
    "get",
    "/v1/community/campaigns/{resourceId}/activities",
    options,
  );
}
async function getCampaignLeaderboard(options) {
  return clientRequest(
    "get",
    "/v1/community/campaigns/{resourceId}/leaderboard",
    options,
  );
}
async function getCampaignRank(options) {
  return clientRequest(
    "get",
    "/v1/community/campaigns/{resourceId}/leaderboard/{safeAddress}",
    options,
  );
}
async function getLeaderboard(options) {
  return clientRequest("get", "/v1/community/locking/leaderboard", options);
}
async function getLockingRank(options) {
  return clientRequest(
    "get",
    "/v1/community/locking/{safeAddress}/rank",
    options,
  );
}
async function getLockingHistory(options) {
  return clientRequest(
    "get",
    "/v1/community/locking/{safeAddress}/history",
    options,
  );
}
async function getContract(options) {
  return clientRequest(
    "get",
    "/v1/chains/{chainId}/contracts/{contractAddress}",
    options,
  );
}
async function getDataDecoded(options) {
  return clientRequest("post", "/v1/chains/{chainId}/data-decoder", options);
}
async function getDelegates(options) {
  return clientRequest("get", "/v1/chains/{chainId}/delegates", options);
}
async function postDelegate(options) {
  return clientRequest("post", "/v1/chains/{chainId}/delegates", options);
}
async function deleteDelegate(options) {
  return clientRequest(
    "delete",
    "/v1/chains/{chainId}/delegates/{delegateAddress}",
    options,
  );
}
async function deleteSafeDelegate(options) {
  return clientRequest(
    "delete",
    "/v1/chains/{chainId}/safes/{safeAddress}/delegates/{delegateAddress}",
    options,
  );
}
async function getDelegatesV2(options) {
  return clientRequest("get", "/v2/chains/{chainId}/delegates", options);
}
async function postDelegateV2(options) {
  return clientRequest("post", "/v2/chains/{chainId}/delegates", options);
}
async function deleteDelegateV2(options) {
  return clientRequest(
    "delete",
    "/v2/chains/{chainId}/delegates/{delegateAddress}",
    options,
  );
}
async function addRecoveryModule(options) {
  return clientRequest(
    "post",
    "/v1/chains/{chainId}/safes/{safeAddress}/recovery",
    options,
  );
}
async function deleteRecoveryModule(options) {
  return clientRequest(
    "delete",
    "/v1/chains/{chainId}/safes/{safeAddress}/recovery/{moduleAddress}",
    options,
  );
}
async function getEstimation(options) {
  return clientRequest(
    "post",
    "/v2/chains/{chainId}/safes/{address}/multisig-transactions/estimations",
    options,
  );
}
async function getMessageByHash(options) {
  return clientRequest(
    "get",
    "/v1/chains/{chainId}/messages/{messageHash}",
    options,
  );
}
async function getMessagesBySafe(options) {
  return clientRequest(
    "get",
    "/v1/chains/{chainId}/safes/{safeAddress}/messages",
    options,
  );
}
async function createMessage(options) {
  return clientRequest(
    "post",
    "/v1/chains/{chainId}/safes/{safeAddress}/messages",
    options,
  );
}
async function updateMessageSignature(options) {
  return clientRequest(
    "post",
    "/v1/chains/{chainId}/messages/{messageHash}/signatures",
    options,
  );
}
async function registerDevice(options) {
  return clientRequest("post", "/v1/register/notifications", options);
}
async function unregisterDevice(options) {
  return clientRequest(
    "delete",
    "/v1/chains/{chainId}/notifications/devices/{uuid}",
    options,
  );
}
async function unregisterSafe(options) {
  return clientRequest(
    "delete",
    "/v1/chains/{chainId}/notifications/devices/{uuid}/safes/{safeAddress}",
    options,
  );
}
async function getSafesByOwner(options) {
  return clientRequest(
    "get",
    "/v1/chains/{chainId}/owners/{ownerAddress}/safes",
    options,
  );
}
async function getAllSafesByOwner(options) {
  return clientRequest("get", "/v1/owners/{ownerAddress}/safes", options);
}
async function relay(options) {
  return clientRequest("post", "/v1/chains/{chainId}/relay", options);
}
async function getRelaysRemaining(options) {
  return clientRequest(
    "get",
    "/v1/chains/{chainId}/relay/{safeAddress}",
    options,
  );
}
async function getSafeApps(options) {
  return clientRequest("get", "/v1/chains/{chainId}/safe-apps", options);
}
async function getSafe(options) {
  return clientRequest(
    "get",
    "/v1/chains/{chainId}/safes/{safeAddress}",
    options,
  );
}
async function getNonces(options) {
  return clientRequest(
    "get",
    "/v1/chains/{chainId}/safes/{safeAddress}/nonces",
    options,
  );
}
async function getSafeOverview(options) {
  return clientRequest("get", "/v1/safes", options);
}
async function getSubmission(options) {
  return clientRequest(
    "get",
    "/v1/targeted-messaging/outreaches/{outreachId}/chains/{chainId}/safes/{safeAddress}/signers/{signerAddress}/submissions",
    options,
  );
}
async function createSubmission(options) {
  return clientRequest(
    "post",
    "/v1/targeted-messaging/outreaches/{outreachId}/chains/{chainId}/safes/{safeAddress}/signers/{signerAddress}/submissions",
    options,
  );
}
async function getTransactionById(options) {
  return clientRequest(
    "get",
    "/v1/chains/{chainId}/transactions/{id}",
    options,
  );
}
async function getMultisigTransactions(options) {
  return clientRequest(
    "get",
    "/v1/chains/{chainId}/safes/{safeAddress}/multisig-transactions",
    options,
  );
}
async function deleteTransaction(options) {
  return clientRequest(
    "delete",
    "/v1/chains/{chainId}/transactions/{safeTxHash}",
    options,
  );
}
async function getModuleTransactions(options) {
  return clientRequest(
    "get",
    "/v1/chains/{chainId}/safes/{safeAddress}/module-transactions",
    options,
  );
}
async function addConfirmation(options) {
  return clientRequest(
    "post",
    "/v1/chains/{chainId}/transactions/{safeTxHash}/confirmations",
    options,
  );
}
async function getIncomingTransfers(options) {
  return clientRequest(
    "get",
    "/v1/chains/{chainId}/safes/{safeAddress}/incoming-transfers",
    options,
  );
}
async function previewTransaction(options) {
  return clientRequest(
    "post",
    "/v1/chains/{chainId}/transactions/{safeAddress}/preview",
    options,
  );
}
async function getTransactionQueue(options) {
  return clientRequest(
    "get",
    "/v1/chains/{chainId}/safes/{safeAddress}/transactions/queued",
    options,
  );
}
async function getTransactionsHistory(options) {
  return clientRequest(
    "get",
    "/v1/chains/{chainId}/safes/{safeAddress}/transactions/history",
    options,
  );
}
async function proposeTransaction(options) {
  return clientRequest(
    "post",
    "/v1/chains/{chainId}/transactions/{safeAddress}/propose",
    options,
  );
}
async function getCreationTransaction(options) {
  return clientRequest(
    "get",
    "/v1/chains/{chainId}/safes/{safeAddress}/transactions/creation",
    options,
  );
}
async function getTransactionConfirmationView(options) {
  return clientRequest(
    "post",
    "/v1/chains/{chainId}/safes/{safeAddress}/views/transaction-confirmation",
    options,
  );
}
//# sourceMappingURL=sdk.js.map
